import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState, useEffect, useRef } from "preact/hooks"

export default function RangeFacet({ facet, sidebarOpen }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id);
    const isSelected = min !== range[0] || max !== range[1];
    const [active, setActive] = useState(isSelected);
    const [ dropdownHeight, setDropdownHeight ] = useState(null);
    const dropdownRef = useRef(null);

    useEffect(() => { // for animating height on expand/collapse
        if(!dropdownHeight && dropdownRef?.current && sidebarOpen) {
            setDropdownHeight(dropdownRef.current.offsetHeight + 40);
        }
    }, [ sidebarOpen, dropdownHeight, dropdownRef, facet ]);

    const toggleActive = () => {
        setActive(prevActive => !prevActive)
    }

    return (
        <li class="filter-group ns-range-facet">
            <button
                class={`filter-group__heading ${active ? 'toggle-target-toggler--is-hidden' : ''}`}
                type="button"
                data-nosto-element="facet"
                aria-controls={`ns-facet-${facet.id}`}
                aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name}`}
                onClick={toggleActive}
            >
                <span class="filter-group__heading__text">
                    {facet.name}
                </span>
                <span class="filter-group__heading__indicator">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-down" aria-hidden="true" focusable="false" role="presentation">
                        <path d="m6 9 6 6 6-6"></path>
                    </svg>
                </span>
            </button>
            <div 
                class={`ns-facet-dropdown filter-group__items toggle-target ${active ? 'ns-active' : ''}`} 
                id={`ns-facet-${facet.id}`}
                style={`--dropdown-height: ${dropdownHeight}px;`}
                aria-hidden={!active}
            >
                <div 
                    class="toggle-target-container ns-range-facet-body ns-d-flex ns-justify-content-between ns-font-4"
                    ref={dropdownRef}
                >
                    <div class="ns-range-col flex-shrink-1">
                        <label for={`ns-${facet.id}-min`} class="ns-form-label">
                            Min.
                        </label>

                        <input 
                            type="number" 
                            className="ns-input-field ns-d-block"
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                    </div>
                    <div class="ns-range-col flex-shrink-1">
                        <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Max.
                        </label>
                        <input
                            type="number" 
                            className="ns-input-field ns-d-block"
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                        />
                    </div>
                </div>
                <RangeSlider id={facet.id} />
            </div>
        </li>
    )
}